<mat-form-field style="width: 100%;">
    <mat-label class="select-placeholder-container">
        <div style="display: flex; flex-direction: row; gap: 2px; align-items: center; justify-content: flex-start;">
            <mat-icon svgIcon="function"></mat-icon>
            <span>{{ 'summaryType' | translate }}</span>
        </div>    
    </mat-label>
    <mat-select [(value)]="data" (selectionChange)="changeValue($event.value)">
        <mat-option [value]="null">-- {{ 'doNotSummarize' | translate | capitalizeFirst }} --</mat-option>
        <mat-option *ngFor="let type of summaryTypes" [value]="type">{{type | translate}}</mat-option>
    </mat-select>
</mat-form-field>